import React from "react";
import { format } from "date-fns";
import DashboardMenu from "./DashboardMenu/DashboardMenu";
import LoadingIndicator from "../../utils/LoadingIndicator/LoadingIndicator";
import {
  UserDashboardState,
  defaultUserDashboardState,
} from "./UserDashboardState";
import { UserDashboardContent } from "./UserDashboardContent";
import axios from "../../utils/Axios/axiosProxy";
import { checkFilled } from "../../utils/Functions/functions";
import { companyItems, menuItems } from "../../utils/Data/dataTexts";
import "./UserDashboard.scss";

export const UserDashboardContext = React.createContext<any>({});
export class UserDashboard extends React.Component<{}, UserDashboardState> {
  constructor(props: {}) {
    super(props);
    this.state = defaultUserDashboardState;
  }

  public componentDidMount() {
    const jwtFromLStorage: string = localStorage.getItem("JWT") as string;
    this.getUserOrdersMessagesFromDB(jwtFromLStorage);
  }

  public getUserOrdersMessagesFromDB = (JWT: string) => {
    axios
      .get("/api/account/orders", {
        headers: {
          Authorization: `Bearer ${JWT}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("GET USER RESPONSE: ", response.statusText);
        this.setState({
          userAccount: response.data.account,
          orders:
            response.data.orders.length > 0
              ? this.createTableDataOrders(response.data.orders)
              : [],
          messages: response.data.messages,
          accountFetched: true,
        });
        this.checkCompanyData(response.data.account);
      })
      .catch((error) => {
        console.log("GET USER ERROR: ", error);
      })
      .catch((error) => console.log("GET USER FROM DB CLIENT ERROR", error));
  };

  public handleNavigation = (step: string) => {
    this.setState({ activeStep: step });
    window.scrollTo(0, 0);
  };
  public checkCompanyData = (profile: any) => {
    if (!checkFilled(profile, companyItems)) {
      this.setState({ modalOpen: true });
    }
  };
  public handleClose = (event: any, reason: any) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ modalOpen: false });
  };
  public createTableDataOrders = (orders: Array<{}>) => {
    let newOrders: Array<{}> = [];
    orders.forEach((order: any) => {
      order.statuslabel = this.state.statusLabels[order.status];
      order.datecreated = format(new Date(order.datecreated), "yyyy-MM-dd");
      order.paymentlabel = this.state.paymentLabels[order.payment];
      if (order.paymentdue.length > 0) {
        order.paymentdue = format(new Date(order.paymentdue), "yyyy-MM-dd");
      } else if (order.paymentdue.length === 0) {
        order.paymentdue = "Processing";
      }
      for (let i in order.etr) {
        if (order.etr[i].length > 0) {
          try {
            order.etr[i] = format(new Date(order.etr[i]), "yyyy-MM-dd hh:mm");
          } catch (error) {
            console.error(error);
          }
        }
      }
      newOrders.push(order);
    });
    return newOrders;
  };

  public updateMessages = (updatedMessages: Object) => {
    this.setState({ messages: updatedMessages });
  };

  public updateOrderMessages = (updatedOrder: any) => {
    let updatedOrders: Array<{}> = this.state.orders;
    updatedOrders.forEach((order: any) => {
      if (order._id === updatedOrder._id) {
        order.messages = updatedOrder.messages;
      }
    });
    this.setState({ orders: updatedOrders });
  };
  render() {
    return (
      <UserDashboardContext.Provider value={this}>
        <div className="DashboardContainer">
          <div className="DashboardMenuContainer">
            <DashboardMenu
              handleNavigation={this.handleNavigation}
              activeStep={this.state.activeStep}
              userAccount={this.state.userAccount}
              menuItems={menuItems}
              user
            />
          </div>
          {this.state.accountFetched && this.state.orders.length > 0 ? (
            <>
              <div className="DasboardContentContainer">
                <UserDashboardContent step={this.state.activeStep} />
              </div>
            </>
          ) : (
            <>
              {this.state.accountFetched && this.state.orders.length === 0 ? (
                <div className="DasboardContentContainer">
                  <p className="WelcomeText">
                    There are no quotations associated with this account yet!
                  </p>
                </div>
              ) : (
                <LoadingIndicator />
              )}
            </>
          )}
        </div>
      </UserDashboardContext.Provider>
    );
  }
}
